import { ID } from '@state/base';
import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { WorkflowState, WorkflowStore } from './workflow.store';

@Injectable({ providedIn: 'root' })
export class WorkflowQuery extends Query<WorkflowState> {
  investorDetails$ = this.select(({ workflow }): { email: string; id: ID; name: string } => ({
    email: workflow?.investor_email,
    id: workflow?.investor_id,
    name: workflow?.investor_name
  }));
  tasks$ = this.select((state) => state.workflow?.tasks);

  constructor(protected store: WorkflowStore) {
    super(store);
  }

  investorMatchesCurrentUser(): boolean {
    return this.getValue().workflow?.investor_is_current_user;
  }
}
